import { Box, Button, Skeleton, Typography } from '@mui/material';
import { IPackage } from '../../interfaces/studio.ts';
import { useTranslation } from 'react-i18next';
import numberFormat from '../../utils/numberFormat.ts';
import { CampaignContext } from '../../contexts/CampaignContext.tsx';
import { useContext } from 'react';
import { Link, useSearchParams } from 'react-router-dom';

const detailsItem = [
	{ name: 'title', value: 'title' },
	{ name: 'category', value: 'category' },
	{ name: 'release-platform', value: 'media' },
	{ name: 'content_type', value: 'content_type' },
	{ name: 'video_creator', value: 'company_title' },
	{ name: 'quality', value: 'quality' },
	{ name: 'price', value: 'price' },
];

export default function ListItems({ data }: { data: IPackage | null }) {
	const { savedCampaignId } = useContext(CampaignContext);
	const [searchParams] = useSearchParams();
	const isCampaign_params = searchParams.get('is_campaign');
	const { t } = useTranslation();
	if (data === null) {
		return (
			<Box className={'border-primary-Outborder flex w-full flex-col justify-center gap-4 rounded-lg border p-4 md:w-80 md:justify-start'}>
				<img className={'h-48 w-full rounded object-cover'} />

				{detailsItem?.map((item, index) => (
					<Box className={'flex justify-between bg-primary-selected px-4 py-2'} key={index}>
						<Typography className={'text-sm text-text-secondary'}>{t(item.name as string)} :</Typography>
						<Typography className={'text-sm'}>
							<Skeleton className={'w-12'} />
						</Typography>
					</Box>
				))}

				<Box className="flex gap-2">
					<Button variant={'contained'} className={'basis-7/12'} disabled>
						{t('order_registration')}
					</Button>
					<Button variant={'outlined'} className={'basis-5/12'} disabled>
						{t('detail')}
					</Button>
				</Box>
			</Box>
		);
	}

	return (
		<Box className={'border-primary-Outborder flex w-full flex-col justify-center gap-4 rounded-lg border p-4 md:w-80 md:justify-start'}>
			<img className={'h-48 w-full rounded object-cover'} src={data?.image} alt={data.title} />

			{detailsItem?.map((item, index) => (
				<Box className={'flex justify-between bg-primary-selected px-4 py-2'} key={index}>
					<Typography className={'text-sm text-text-secondary'}>{t(item.name as string)} :</Typography>
					<Typography className={'text-sm'}>{item?.name === 'price' ? numberFormat(data?.[item.value as keyof typeof data]) : data?.[item.value as keyof typeof data]}</Typography>
				</Box>
			))}

			<Box className="flex gap-2">
				<Link to={`/studio/create/${data?.id}?campaign_id=${(isCampaign_params && savedCampaignId) ?? ''}`} className={'basis-7/12'}>
					<Button variant={'contained'} fullWidth>
						{t('order_registration')}
					</Button>
				</Link>
				<Link to={`/studio/detail/${data?.id}`} className={'basis-5/12'}>
					<Button variant={'outlined'} fullWidth>
						{t('detail')}
					</Button>
				</Link>
			</Box>
		</Box>
	);
}
